<template>
  <el-select
    v-model="local_value"
    class="sp-select"
    :popper-class="`sp-select-popper sp-select-popper-${type}`"
    v-bind="$attrs"
    v-on="$listeners"
    @remove-tag="emittedEvent"
  >
    <sp-option v-for="raw in local_data" v-show="!(['panel'].includes(type))" :key="raw.value" :label="raw.label" :value="raw.value" />
    <sp-option v-if="type === 'panel'" :value="null" @click.stop>
      <option-panel :value="local_value" :data="local_data" :multiple-limit="$attrs['multipleLimit']" @change="onChange" />
    </sp-option>
  </el-select>
</template>

<script>
import { deepClone } from './utils';

export default {
  name: 'SpSelect',
  components: {
    'option-panel': () => import('./option-panel.vue'),
    'sp-option': () => import('./option.vue'),
  },
  model: {
    event: 'update:value',
    prop: 'value',
  },
  props: {
    type: {
      type: String,
      default: 'default',
    },
    value: {
      type: [Boolean, String, Number, Array, Object],
      default() {
        return [];
      },
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      local_value: [],
      local_data: [],
    };
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(val) {
        const copy_value = deepClone(val);
        this.local_value = copy_value;
      },
    },
    options: {
      deep: true,
      immediate: true,
      handler(val) {
        const copy_value = deepClone(val);
        this.local_data = copy_value;
      },
    },
  },
  methods: {
    /**
     * 选项改变时触发
     * @param {Array} val 已选中选项列表
     * @returns {void}
     */
    onChange(val) {
      const copy_value = deepClone(val);
      this.local_value = copy_value;
      this.emittedEvent();
    },
    /**
     * 发送事件
     * @returns {void}
     */
    emittedEvent() {
      const copy_value = deepClone(this.local_value);
      this.$emit('update:value', copy_value);
      this.$emit('change', copy_value);
    },
  },
};
</script>
